<template>
  <div class="page-header">
    <h1 data-speed="1.2">{{ textes[currentLanguage].PresentationTitle }}</h1>
  </div>
  <div>
    <p class="intro-text">{{ textes[currentLanguage].Introduction }}</p>
  </div>
  <div class="savoir-faire">
    <h2 data-speed="1.1">{{ textes[currentLanguage].SavoirFaireTitle }}</h2>
    <div>
      <div data-speed="1" class="savoir-item gainerie">
        <div class="texts">
          <h3>{{ textes[currentLanguage].GainerieTitle }}</h3>
          <p>{{ textes[currentLanguage].GainerieDescription }}</p>
        </div>
        <svg width="136" height="192" viewBox="0 0 136 192" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="33.5" cy="158.298" rx="33.5" ry="33.7021" fill="#7B6E68"/><path d="M52.2803 124.844C52.2803 129.211 45.6486 127.195 35.2765 127.195C24.9044 127.195 14.7197 129.211 14.7197 124.844C14.7197 120.477 23.1279 116.936 33.5 116.936C43.8721 116.936 52.2803 120.477 52.2803 124.844Z" fill="#7B6E68"/><rect x="14.7197" y="124.596" width="37.5606" height="16.8511" fill="#7B6E68"/><path d="M29.947 15.8298H37.053V119.489H29.947V15.8298Z" fill="#7B6E68"/><path d="M33.5 0L29.947 15.8298H37.053L33.5 0Z" fill="#7B6E68"/><rect x="136" y="184.136" width="25" height="123.195" rx="12.5" transform="rotate(-180 136 184.136)" fill="#7B6E68"/><ellipse cx="123.342" cy="174.307" rx="12.3418" ry="17.6928" transform="rotate(-180 123.342 174.307)" fill="#7B6E68"/><ellipse cx="123.342" cy="69.7885" rx="12.3418" ry="69.7884" transform="rotate(-180 123.342 69.7885)" fill="#7B6E68"/></svg>
      </div>
      <div data-speed="1.2" class="savoir-item realisation">
        <img src="../assets/images-home/Realisations.png" alt="">
        <div class="texts">
          <h3>{{ textes[currentLanguage].RealisationTitle }}</h3>
          <p>{{ textes[currentLanguage].RealisationDescription }}</p>
        </div>
      </div>
      <div data-speed="1.4" class="savoir-item maroquinerie">
        <div class="texts">
          <h3>{{ textes[currentLanguage].MaroquinerieTitle }}</h3>
          <p>{{ textes[currentLanguage].MaroquinerieDescription }}</p>
        </div>
        <svg width="132" height="159" viewBox="0 0 132 159" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M131.822 117.924C131.704 117.479 131.497 117.063 131.213 116.701C130.929 116.34 130.574 116.04 130.17 115.821C125.159 112.7 121.048 108.325 118.242 103.126C115.436 97.9271 114.032 92.085 114.168 86.1765C114.168 68.9412 126.212 62.8399 126.729 62.5986C127.314 62.3196 127.81 61.8802 128.157 61.3312C128.504 60.7822 128.689 60.1461 128.69 59.4962V29.8171C128.689 28.9702 128.376 28.1535 127.811 27.5236C127.245 26.8938 126.468 26.4953 125.627 26.4045C117.538 25.4702 109.75 22.7774 102.807 18.5143C95.8651 14.2512 89.9359 8.5208 85.4345 1.72354C85.1303 1.19833 84.6936 0.762556 84.168 0.460015C83.6425 0.157474 83.0467 -0.00117637 82.4406 6.56706e-06H49.543C48.9368 -0.00117637 48.3411 0.157474 47.8156 0.460015C47.29 0.762556 46.8533 1.19833 46.5492 1.72354C42.0477 8.5208 36.1185 14.2512 29.1761 18.5143C22.2337 22.7774 14.4456 25.4702 6.35621 26.4045C5.51563 26.4953 4.73814 26.8938 4.17291 27.5236C3.60768 28.1535 3.29454 28.9702 3.29356 29.8171V59.4962C3.29495 60.1461 3.47988 60.7822 3.82697 61.3312C4.17407 61.8802 4.66916 62.3196 5.25503 62.5986C9.30709 64.9955 12.6224 68.4633 14.8379 72.6221C17.0533 76.7809 18.0834 81.4703 17.8153 86.1765C17.9521 92.085 16.548 97.9271 13.7418 103.126C10.9356 108.325 6.82433 112.7 1.81386 115.821C1.41064 116.038 1.0541 116.332 0.764726 116.687C0.475356 117.042 0.258858 117.45 0.127677 117.889C0.00295325 118.332 -0.0308543 118.796 0.0282919 119.252C0.0874381 119.708 0.238311 120.147 0.471796 120.544L13.6171 143.639C14.0303 144.36 14.6898 144.907 15.4739 145.179C16.258 145.452 17.114 145.431 17.8842 145.121C18.1939 145.018 48.1665 133.367 62.9636 156.772C63.2425 157.299 63.6588 157.739 64.168 158.048C64.2024 158.048 64.2024 158.082 64.2368 158.082C64.4858 158.252 64.7668 158.369 65.0627 158.427C65.6685 158.611 66.3151 158.611 66.9209 158.427C67.2168 158.369 67.4978 158.252 67.7468 158.082C68.2169 157.795 68.6167 157.407 68.9168 156.945C68.9512 156.876 68.9856 156.841 69.02 156.772C83.7483 133.436 112.861 144.639 114.099 145.121C114.87 145.431 115.726 145.452 116.51 145.179C117.294 144.907 117.953 144.36 118.367 143.639L131.512 120.544C131.747 120.154 131.896 119.719 131.95 119.267C132.003 118.815 131.959 118.357 131.822 117.924ZM65.9918 31.0235C65.3112 31.0235 64.6459 30.8214 64.08 30.4426C63.5141 30.0638 63.073 29.5255 62.8126 28.8956C62.5521 28.2657 62.484 27.5726 62.6167 26.904C62.7495 26.2353 63.0773 25.6211 63.5585 25.139C64.0398 24.657 64.6529 24.3287 65.3205 24.1957C65.988 24.0626 66.6799 24.1309 67.3087 24.3918C67.9375 24.6527 68.4749 25.0945 68.853 25.6614C69.2312 26.2283 69.433 26.8947 69.433 27.5765C69.4303 28.4899 69.0669 29.3651 68.4222 30.011C67.7774 30.6569 66.9036 31.0209 65.9918 31.0235Z" fill="#7B6E68"/></svg>
      </div>
      <div data-speed="1.5" class="savoir-item creation">
        <svg width="104" height="152" viewBox="0 0 104 152" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.125 134.051V122.625H74.707V134.051C74.707 135.809 74.1211 137.566 73.2422 139.324L68.2617 146.648C66.5039 149.285 63.5742 151.043 60.3516 151.043H42.4805C39.2578 151.043 36.3281 149.285 34.5703 146.648L29.5898 139.324C28.418 137.566 28.125 135.809 28.125 134.051ZM0 52.3125C0 25.0664 21.3867 1.04297 51.2695 0.75C79.6875 0.75 103.125 23.8945 103.125 52.3125C103.125 65.4961 98.1445 77.2148 90.2344 86.2969C85.2539 91.8633 77.9297 103.582 75 113.25C75 113.25 75 113.25 75 113.543H27.832C27.832 113.25 27.832 113.25 27.832 113.25C24.9023 103.582 17.5781 91.8633 12.5977 86.2969C4.6875 77.2148 0 65.4961 0 52.3125ZM51.5625 28.875C53.9062 28.875 56.25 26.8242 56.25 24.1875C56.25 21.8438 53.9062 19.5 51.5625 19.5C33.3984 19.5 18.75 34.4414 18.75 52.3125C18.75 54.9492 20.8008 57 23.4375 57C25.7812 57 28.125 54.9492 28.125 52.3125C28.125 39.4219 38.3789 28.875 51.5625 28.875Z" fill="#7B6E68"/></svg>
        <div class="texts">
          <h3>{{ textes[currentLanguage].CreationDesignTitle }}</h3>
          <p>{{ textes[currentLanguage].CreationDesignDescription }}</p>
        </div>
      </div>
      <div data-speed="1.4" class="savoir-item menuiserie">
        <div class="texts">
          <h3>{{ textes[currentLanguage].MenuiserieTitle }}</h3>
          <p>{{ textes[currentLanguage].MenuiserieDescription }}</p>
        </div>
        <img src="../assets/images-home/menuiserie.png" alt="">
      </div>
    </div>
  </div>
  <div :style="{ 
    backgroundImage: `url(${require('../assets/images-home/atelier.jpg')})`, 
    height: '300px', 
    marginBottom: '2rem', 
    backgroundPosition: 'center', 
    backgroundSize: 'cover'
  }"
  ></div>
  <div>
    <h2 class="atelier-h2">{{ textes[currentLanguage].AtelierTitle }}</h2>
    <div class="atelier-aligner">
      <p>{{ textes[currentLanguage].AtelierDescription1 }}</p>
      <p>{{ textes[currentLanguage].AtelierDescription2 }}</p>
    </div>
  </div>
  <div class="realisation-teaser">
    <div>
      <h2>{{ textes[currentLanguage].RealisationTeaserTitle }}</h2>
      <p>{{ textes[currentLanguage].RealisationTeaserDescription }}</p>
      <RouterLink to="/creations" class="button">{{ textes[currentLanguage].RealisationTeaserButton }}</RouterLink>
    </div>
    <img src="../assets/images-home/boite-real.jpg" alt="">
  </div>
  <leFooter/>
    <div class="spacer-footer"></div>
</template>

<script>
export default {
  data() {
    return {
      currentLanguage: localStorage.getItem("Language") || "fr-CH",
      textes: {
        "fr-CH": {
          PresentationTitle: "Présentation",
          Introduction: "Métier d’art du XIVème siècle, la gainerie permet de couvrir le bois par le cuir, aujourd’hui, le choix des matières est très large et laisse libre cours à la créativité. Depuis 1908, VAUDAUX perpétue ces savoir-faire et est à disposition du Luxe.",
          SavoirFaireTitle: "Savoir-faire",
          GainerieTitle: "Gainerie",
          GainerieDescription: "Nos artisans gainiers perpétuent l’unique savoir-faire VAUDAUX. Précision, souci du détail, délicatesse des coupes et des assemblages confèrent aux réalisations VAUDAUX une signature unique.",
          RealisationTitle: "Réalisations",
          RealisationDescription: "Soucieux du moindre détail des attentes de nos clients, nous concevons et réalisons nos objets en associant matières et esthétisme dans une harmonie toujours fonctionnelle.",
          MaroquinerieTitle: "Maroquinerie",
          MaroquinerieDescription: "La confection de petites et moyennes maroquineries se nourrie de matières nobles et tout spécialement sélectionnées et choisies. Les finitions élégantes et les détails chics naissent du savoir-faire de nos artisans.",
          CreationDesignTitle: "Création & design",
          CreationDesignDescription: "Notre studio est très à l’écoute afin d’identifier et de s’imprégner de la quintessence des Maisons pour lesquelles nous créons. Nous sommes fiers de savoir préserver et mettre en valeur l’identité de chaque marque.",
          MenuiserieTitle: "Menuiserie",
          MenuiserieDescription: "Notre Atelier de menuiserie élabore nos bases dans la tradition ancestrale de nos compagnons. Authenticité et rigueur se mêlent à l’originalité et à la pertinence de nos savoir-faire.",
          AtelierTitle: "L'atelier",
          AtelierDescription1: "L’Atelier Genevois emploie environ 35 personnes hautement qualifiées, dédiées à répondre aux exigences de ses clients pour la fabrication d’une pièce unique jusqu’à la réalisation de petites et moyennes séries. Les matières premières utilisées comprennent le cuir, des tissus exclusifs, des bois précieux, les métaux nobles et des matériaux modernes et innovants.",
          AtelierDescription2: "En plus de ses infrastructures de production à Genève, un partenariat de plus de 30 ans est établi en Chine et garantit une production de haute qualité pour les plus grandes séries à des prix adaptés. De plus, et pour toujours mieux satisfaire nos partenaires, nous avons établi nos propres lignes de productions en Thaïlande et en Espagne.",
          RealisationTeaserTitle: "Réalisations",
          RealisationTeaserDescription: "Depuis plus d’un siècle, les artisans de la maison perpétuent leur savoir-faire, toujours soucieux du détail, de la délicatesse des coupes et des assemblages, offrant une qualité sans égale aux écrins et autres présentoirs qui mettront en valeur des objets de haute horlogerie ou joaillerie.",
          RealisationTeaserButton: "Voir nos Réalisations",
        },
        "en-US": {
          PresentationTitle: "Presentation",
          Introduction: "A craft from the 14th century, gainerie involves covering wood with leather. Today, the choice of materials is vast, allowing for great creative freedom. Since 1908, VAUDAUX has been preserving this expertise and remains at the service of the luxury industry.",
          SavoirFaireTitle: "Know-How",
          GainerieTitle: "Leather Craft",
          GainerieDescription: "Our craftsmen perpetuate the unique VAUDAUX know-how. Precision, attention to detail, delicate cuts, and assemblies give VAUDAUX creations a unique signature.",
          RealisationTitle: "Achievements",
          RealisationDescription: "Attentive to every detail of our clients' expectations, we design and create our objects by combining materials and aesthetics in a consistently functional harmony.",
          MaroquinerieTitle: "Leather Goods",
          MaroquinerieDescription: "The creation of small and medium leather goods is nourished by noble and carefully selected materials. Elegant finishes and chic details are born from the expertise of our artisans.",
          CreationDesignTitle: "Creation & Design",
          CreationDesignDescription: "Our studio is highly attentive to identifying and absorbing the essence of the Houses for which we create. We take pride in preserving and enhancing the identity of each brand.",
          MenuiserieTitle: "Carpentry",
          MenuiserieDescription: "Our carpentry workshop develops our bases in the ancestral tradition of our craftsmen. Authenticity and rigor blend with the originality and relevance of our expertise.",
          AtelierTitle: "The Workshop",
          AtelierDescription1: "The Geneva Workshop employs around 35 highly skilled people dedicated to meeting the demands of its clients, from the creation of a unique piece to the production of small and medium series. The raw materials used include leather, exclusive fabrics, precious woods, noble metals, and modern, innovative materials.",
          AtelierDescription2: "In addition to its production facilities in Geneva, a partnership of more than 30 years has been established in China, ensuring high-quality production for the largest series at competitive prices. Additionally, and to better satisfy our partners, we have established our own production lines in Thailand and Spain.",
          RealisationTeaserTitle: "Creations",
          RealisationTeaserDescription: "For over a century, the craftsmen of the house have perpetuated their know-how, always attentive to detail, delicate cuts, and assemblies, offering unparalleled quality to the cases and other displays that will showcase fine watchmaking or jewelry pieces.",
          RealisationTeaserButton: "See our Chreations",
        },
      },
    };
  },
};
</script>

<script setup>
import leFooter from "../components/Footer.vue";
import { onMounted, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollSmoother);

onMounted(() => {
  // Initialisation de ScrollSmoother après le montage du composant
  const smoother = ScrollSmoother.create({
    smooth: 2,
    effects: true,
    smoothTouch: 0.1,
  });

  // Fonction pour changer les valeurs data-speed sur mobile
  const updateDataSpeedForMobile = () => {
    const mobileWidthThreshold = 768;
    if (window.innerWidth < mobileWidthThreshold) {
      // Sélectionner tous les éléments avec l'attribut data-speed
      const elements = document.querySelectorAll('[data-speed]');
      elements.forEach(el => {
        el.setAttribute('data-speed', '1');
      });
    }
  };

  // Exécuter la fonction lors du chargement initial
  updateDataSpeedForMobile();

  // Ajouter un écouteur d'événements pour surveiller les changements de taille d'écran
  window.addEventListener('resize', updateDataSpeedForMobile);

  // Nettoyer les écouteurs d'événements et ScrollSmoother lors du démontage du composant
  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateDataSpeedForMobile);
    smoother.destroy();
  });
});
</script>

<style scoped>
.page-header {
  background-image: url(../assets/images-home/0K6A1107.jpg);
}

.intro-text {
  margin: 6rem auto;
  margin-bottom: 10rem;
  width: 70%;
}

.savoir-faire {
  margin: 4rem 3rem;
}

.savoir-faire h2 {
  margin-bottom: 2rem;
}

.savoir-item {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin: 3rem 0;
}

.atelier-aligner {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 2rem 3% 5rem 3%;
}

.atelier-h2 {
  margin:0 0 2rem 3%;
}

.realisation-teaser {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  margin: 7rem 2rem 5rem 2rem;
}

.savoir-item svg, 
.savoir-item img {
  display: none;
}

p {
  font-size: 1.2rem;
}

@media screen and (min-width: 755px) {
  
  .gainerie, 
  .maroquinerie,
  .menuiserie {
    margin-left: calc(80% / 6);
  }
  
  .atelier-aligner {
    flex-direction: row;
    justify-content: space-between; 
  }
  
  .atelier-aligner p {
    width: 49%;
  }

  
  .texts {
    width: 65%;
    margin-right: 5%;
  }
  
  .savoir-faire h2 {
    margin-bottom: 4rem;
  }
  
  .savoir-item {
    margin-bottom: 1rem;
    flex-direction: row;
    align-items: center;
  }
  
  .savoir-item svg {
    min-height: 100%;
    display: block;
  }
  
  .savoir-item img {
    display: block;
    max-height: 13rem;
  }

  .gainerie, 
  .maroquinerie, 
  .creation {
    width: 80%;
  }
  
  .creation, 
  .realisation {
    width: 100%;
    margin-left: 0;
  }
}

@media screen and (min-width: 1110px) { 
  
  .realisation-teaser {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 7rem 2rem 5rem 2rem;
  }

  .gainerie, 
  .maroquinerie, 
  .menuiserie {
    width: 40%;
  }
  
  .realisation-teaser div, 
  .realisation-teaser img {
    width: 48%;
  }

  .creation, 
  .realisation {
    width: 40%;
    margin-left: 50%;
  }

  .realisation {
    margin-top: 100px;
  }

}
</style>